const scoreData = (xmlElement) => {
    const ScoreDataParent = xmlElement.getElementsByTagName("cb:ScoreData")[0];
    const ScoreRaw = ScoreDataParent?.attributes?.ScoreRaw?.value ?? '';
    const ScoreRange = ScoreDataParent?.attributes?.ScoreRange?.value ?? '';

    const ScoreMessageParent = xmlElement.getElementsByTagName("cb:ScoreMessage")[0];
    const Code = ScoreMessageParent?.attributes?.Code?.value ?? ''
    const Description = ScoreMessageParent?.attributes?.Description?.value ?? ''

    const ExclusionRuleParent = xmlElement.getElementsByTagName('cb:ExclusionRule')[0]
    const CodeExclusionRule = ExclusionRuleParent?.attributes?.Code?.value ?? ''
    const DescriptionExclusionRule = ExclusionRuleParent?.attributes?.Description?.value ?? ''

    const result = {
        ScoreData: {
            ScoreRaw,
            ScoreRange,
            Code,
            Description,
        },
        ExclusionRule: {
            CodeExclusionRule,
            DescriptionExclusionRule,
        },
    }

    return result;
}

export default scoreData;